import chat_profile from "../../../assets/images/chat_profile.png";

const ConversationList = ({
  t,
  lang,
  conversations,
  selectedId,
  loading,
  loadingMore,
  error,
  hasMore,
  onSelect,
  onLoadMore,
}) => {
  return (
    <div className="my-card my-chat-card-left">
      <div className="my-chat-conversation">
        <strong>{t("messages")}</strong>

        <div className="chat-lists mt-3">
          {loading &&
            Array.from({ length: 5 }).map((_, i) => (
              <div key={i} className="chat-item placeholder-glow">
                <div className="chat-item-header">
                  <div className="chat-avatar">
                    <span className="placeholder rounded-circle" style={{ width: 40, height: 40, display: "inline-block" }} />
                  </div>
                  <div className="chat-user-info w-100">
                    <span className="placeholder col-8 d-block mb-1"></span>
                    <span className="placeholder col-5 d-block"></span>
                  </div>
                </div>
              </div>
            ))}

          {!loading && error && (
            <div className="text-center text-danger py-3">{t("failedToLoadConversations")}</div>
          )}

          {!loading && !error && conversations.length === 0 && (
            <div className="text-center text-muted py-3">{t("noConversationsFound")}</div>
          )}

          {!loading &&
            conversations.map((conv) => {
              const customerUnread = conv.unreadCounts?.[conv.customerId] || 0;
              const providerUnread = conv.unreadCounts?.[conv.providerId] || 0;

              return (
                <div
                  key={conv.conversationId}
                  className={`chat-item cursor-pointer ${
                    conv.conversationId === selectedId ? "chat-item-selected" : ""
                  }`}
                  onClick={() => onSelect(conv)}
                >
                  <div className="chat-item-header">
                    <div className="chat-avatar">
                      <img src={chat_profile} alt="profile" />
                    </div>
                    <div className="chat-user-info">
                      <strong>
                        {conv.customerName || t("Customer")}
                        <i className="fas fa-arrow-right-arrow-left mx-2 text-muted small"></i>
                        {conv.providerName || t("provider")}
                      </strong>
                      <span className="text-muted small">
                        {conv.lastMessageAt ? conv.lastMessageAt.toChatDate(lang) : ""}
                      </span>
                    </div>
                    {(customerUnread > 0 || providerUnread > 0) && (
                      <div className="d-flex flex-column gap-1">
                        {customerUnread > 0 && (
                          <span
                            className="badge bg-danger rounded-pill"
                            title={t("Customer")}
                          >
                            {customerUnread}
                          </span>
                        )}
                        {providerUnread > 0 && (
                          <span
                            className="badge bg-warning text-dark rounded-pill"
                            title={t("provider")}
                          >
                            {providerUnread}
                          </span>
                        )}
                      </div>
                    )}
                  </div>
                  <div className="chat-item-body">
                    <span className="chat-message-preview single-line text-muted">
                      {conv.lastMessage || t("noMessagesYet")}
                    </span>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
      <div className="chat-pagination">
        <button
          className="chat-pagination-button"
          disabled={!hasMore || loadingMore}
          onClick={onLoadMore}
        >
          <i className="fas fa-chevron-right"></i>
        </button>
      </div>
    </div>
  );
};

export default ConversationList;
